import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, NgModule, ViewChild, } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrettyPrinter } from '../helpers/pretty-printer.service';


export class CodeSampleComponent implements AfterViewInit {
	 public codeContainer: ElementRef;
	 public language: string;

	 set code(code: string) {
		this._code = code;
		this.formatDisplayedCode();
	}

	private _code: string;
	private prettyPrinterService = new PrettyPrinter();

	public async ngAfterViewInit() {
		this.formatDisplayedCode();
	}

	private formatDisplayedCode() {
		if (!this._code || !this._code.trim()) {
			this.showMissingCodeMessage();
			return;
		}

		this.setCodeHtml(this.prettyPrinterService.formatCode(this._code, this.language || '', true));
	}

	private setCodeHtml(formattedCode: string) {
		if (!this.codeContainer) {
			return;
		}
		this.codeContainer.nativeElement.innerHTML = formattedCode;
	}

	private showMissingCodeMessage() {
		this.setCodeHtml(`<div class="code-missing">The code sample is missing</div>`);
	}
}


export class CodeSampleModule {
}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/shared/components/code-sample.module.ts